import styles from "./Notification.module.scss";
import CloseIcon from "../../icons/x.svg?react";
import {
  sizeClassMap,
  toneClassMap,
  toneIconMap,
  variantClassMap,
} from "./Notification.constants";
import type { NotificationProps } from "./Notification.types";
import { cn } from "../../utils/cn";

// TODO: rename this to Toast
export function Notification({
  className,
  tone = "success",
  size = "desktop",
  variant = "default",
  title,
  body,
  icon,
  showIcon = true,
  showClose,
  closeAriaLabel = "Dismiss notification",
  onClose,
  actions,
  ...rest
}: NotificationProps) {
  const classes = cn(
    styles.Notification,
    styles[toneClassMap[tone]],
    styles[sizeClassMap[size]],
    styles[variantClassMap[variant]],
    className,
  );

  const shouldRenderIcon = showIcon && icon !== null;
  const ToneIcon = toneIconMap[tone];
  const iconContent =
    icon ?? (
      <ToneIcon
        aria-hidden="true"
        focusable="false"
      />
    );

  const shouldRenderClose = showClose ?? Boolean(onClose);

  const shouldRenderTitle =
    variant === "title" && title !== null && title !== undefined;
  const shouldRenderBody = body !== null && body !== undefined;

  const shouldRenderActions = variant === "title" && actions;

  return (
    <div className={classes} {...rest}>
      <div className={styles.Top}>
        {shouldRenderIcon ? (
          <span
            className={styles.Icon}
            aria-hidden="true"
          >
            {iconContent}
          </span>
        ) : null}
        <div className={styles.Content}>
          {shouldRenderTitle ? (
            <div className={styles.Title}>{title}</div>
          ) : null}
          {shouldRenderBody ? (
            <div className={styles.Body}>{body}</div>
          ) : null}
        </div>
        {shouldRenderClose ? (
          <button
            type="button"
            className={styles.Close}
            onClick={onClose}
            aria-label={closeAriaLabel}
          >
            <CloseIcon aria-hidden="true" focusable="false" />
          </button>
        ) : null}
      </div>
      {shouldRenderActions ? (
        <div className={styles.Actions}>{actions}</div>
      ) : null}
    </div>
  );
}
